module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/img-15797cb6155d5dbe6ed8b5ca49aee366.png";